import { render, staticRenderFns } from "./TiposFichajeFormulario.vue?vue&type=template&id=691f0150&"
import script from "./TiposFichajeFormulario.vue?vue&type=script&lang=ts&"
export * from "./TiposFichajeFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports